import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import WavesurferPlayer from '@wavesurfer/react';
import Controls from './Controls';
import mobileCheck from '../../helpers/mobileDetector';
import { getDarkerThemeColor } from '../theme/colors';

const WaveContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const AudioPlayer = ({ url, themeColor, miniAudio, downloadFile }) => {
  const [wavesurfer, setWavesurfer] = useState(null);
  const audioRef = useRef(null);
  const isMobile = mobileCheck();
  const onReady = (ws) => setWavesurfer(ws);

  if (!url) return null;

  return (
    <WaveContainer>
      {miniAudio || isMobile ? <>
          <audio ref={audioRef} src={url} preload='metadata' controlsList='nodownload'/>
          <Controls themeColor={themeColor} audioRef={audioRef} downloadFile={downloadFile}/>
        </>
        : <>
          <WavesurferPlayer
            height={70}
            width='100%'
            waveColor={getDarkerThemeColor(themeColor)}
            progressColor={themeColor}
            url={url}
            cursorColor='transparent'
            mediaControls={false}
            barGap='1'
            barRadius='20'
            barWidth='2'
            onReady={onReady}
          />
          <Controls themeColor={themeColor} wavesurfer={wavesurfer} downloadFile={downloadFile}/>
        </>
      }
    </WaveContainer>
  );
};

export default AudioPlayer;
